type ClassName = string;

export type StepperTheme = {
  // Dot (Step) base styling (non-active/non-completed state)
  dotBaseStructuralClassName: ClassName;
  dotBaseColorClassName: ClassName;
  dotSizeClassName: ClassName;

  // Active/completed dot "color" strings
  activeDotColorClassName: ClassName;
  completedDotColorClassName: ClassName;

  // Structural state classes applied by Stepper via cloneElement (must match existing)
  activeStepStructuralClassName: ClassName;
  completedStepStructuralClassName: ClassName;

  // Line styling
  lineThicknessHorizontalClassName: ClassName;
  lineThicknessVerticalClassName: ClassName;
  lineInactiveColorClassName: ClassName;
  lineActiveColorClassName: ClassName;
  lineActiveMotionClassName: ClassName;

  // Ring CSS variable defaults (must match existing)
  ringGapColor: string;
  ringColor: string;
  ringGapSize: string;
  ringOutlineSize: string;

  // Label placement classes (existing)
  labelPosRightClassName: ClassName;
  labelPosBottomClassName: ClassName;

  // Label base classes (existing)
  labelBaseAbsoluteClassName: ClassName;
  labelBaseFlowClassName: ClassName;
};

export const STEPPER_THEME: StepperTheme = {
  // Existing Step dot base styles (structural)
  dotBaseStructuralClassName:
    "relative z-10 grid place-items-center rounded-full transition-all duration-300 overflow-visible",

  // Existing Step dot base styles (color)
  dotBaseColorClassName: "bg-blue-200 text-gray-600",

  // Existing usage in QuestionsAnswers (h-2 w-2) — provided as a helper token
  dotSizeClassName: "h-2 w-2",

  // Existing dot colors for active/completed
  activeDotColorClassName: "bg-blue-700",
  completedDotColorClassName: "bg-blue-700",

  // Existing active/completed structural classes (ring shadow stays here)
  activeStepStructuralClassName:
    "select-none shadow-[0_0_0_var(--stepper-ring-gap-size)_var(--stepper-ring-gap),0_0_0_var(--stepper-ring-outline-size)_var(--stepper-ring-color)]",
  completedStepStructuralClassName: "select-none",

  // Existing line thickness + colors
  lineThicknessHorizontalClassName: "h-0.5",
  lineThicknessVerticalClassName: "w-0.5",
  lineInactiveColorClassName: "bg-blue-100",
  lineActiveColorClassName: "bg-blue-700",
  lineActiveMotionClassName: "transition-all duration-500",

  // Existing CSS var defaults
  ringGapColor: "#F6F6F6",
  ringColor: "#1D4ED8",
  ringGapSize: "4px",
  ringOutlineSize: "5px",

  // Existing label positioning classes
  labelPosRightClassName: "left-full top-1/2 ml-5 -translate-y-1/2",
  labelPosBottomClassName: "left-0 top-full mt-2",

  // Existing label base classes
  labelBaseAbsoluteClassName: "absolute whitespace-nowrap select-none",
  labelBaseFlowClassName: "mt-2 whitespace-nowrap select-none",
};
